import { render } from "./NotificationBanner.vue?vue&type=template&id=0d4315a4&scoped=true"
import script from "./NotificationBanner.vue?vue&type=script&lang=js"
export * from "./NotificationBanner.vue?vue&type=script&lang=js"

import "./NotificationBanner.vue?vue&type=style&index=0&id=0d4315a4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4315a4"]])

export default __exports__